import React from 'react'
import type { SlideProps as MuiSlideProps } from '@material-ui/core/Slide'
import MuiSlide from '@material-ui/core/Slide'

export type SlideProps = MuiSlideProps

const Slide = React.forwardRef<unknown, SlideProps>(function Slide(props, ref) {
  return <MuiSlide ref={ref} {...props} />
})

export default Slide
